// extracted by mini-css-extract-plugin
module.exports = {"item":"_9EfVlMHGMgJ_LpUl09hl0","link":"_3_S5kGeFGOdI5DrTTOYjvS","delete":"_3yQspKq9zJb6bTkadlPttq","divider":"_39FVSumcrcrhwJPlhsydvK"};